export default __webpack_public_path__ + "static/media/opportunity.24af2de6.png";